import { render, staticRenderFns } from "./ReportsHACCP.vue?vue&type=template&id=66b28058&"
import script from "./ReportsHACCP.vue?vue&type=script&lang=js&"
export * from "./ReportsHACCP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports